import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const UserTriple = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M12 18h3.333c.221 0 .433-.09.59-.251a.87.87 0 0 0 .244-.606v-.857a2.6 2.6 0 0 0-.733-1.819 2.47 2.47 0 0 0-1.767-.753H12m-1.863-3.428c.337.388.781.662 1.273.784.492.123 1.01.09 1.482-.096.473-.186.88-.515 1.167-.944a2.63 2.63 0 0 0 .001-2.917 2.5 2.5 0 0 0-1.168-.944 2.44 2.44 0 0 0-1.482-.096 2.5 2.5 0 0 0-1.273.784M17.833 18h3.334c.22 0 .433-.09.589-.251a.87.87 0 0 0 .244-.606v-.857a2.6 2.6 0 0 0-.732-1.819 2.47 2.47 0 0 0-1.768-.753h-1.667m-1.863-3.428c.338.388.782.662 1.274.784.492.123 1.009.09 1.481-.096s.88-.515 1.167-.944a2.6 2.6 0 0 0 .441-1.459c0-.52-.153-1.029-.44-1.458a2.5 2.5 0 0 0-1.168-.944 2.44 2.44 0 0 0-1.481-.096 2.5 2.5 0 0 0-1.274.784M2 17.143v-.857c0-.682.263-1.336.732-1.819a2.47 2.47 0 0 1 1.768-.753h3.333c.663 0 1.3.271 1.768.753a2.6 2.6 0 0 1 .732 1.819v.857a.87.87 0 0 1-.244.606A.82.82 0 0 1 9.5 18H2.833a.82.82 0 0 1-.589-.251.87.87 0 0 1-.244-.606ZM8.667 8.57a2.6 2.6 0 0 1-.733 1.819 2.47 2.47 0 0 1-1.767.753 2.47 2.47 0 0 1-1.768-.753 2.6 2.6 0 0 1-.732-1.819c0-.682.263-1.336.732-1.818A2.47 2.47 0 0 1 6.167 6c.663 0 1.299.27 1.767.753a2.6 2.6 0 0 1 .733 1.818Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(UserTriple) as SvgIcon;
export { ForwardRef as ReactComponent };
